import "./Watches.css"
import Product1 from "../Components/Product1"
import Watches1 from "../images/w1.jpg"
import Watches2 from "../images/w2.jpg"
import Watches3 from "../images/w3.jpg"
import Watches4 from "../images/w4.jpg"
import Watches5 from "../images/w5.jpg"
import Watches6 from "../images/w6.jpg"
import Watches7 from "../images/w7.jpg"
import Watches8 from "../images/w8.jpg"
import Watches9 from "../images/watchmadd.jpg"

export default function Watches() {

  return (
    <div className="stdivinhome">
       <div className="add"><img src={Watches9} /></div>
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <strong><Product1 id="watchem1"  prdName="FOSSIL" img={Watches1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1></strong>
            <strong>  <Product1 id="watchem2" prdName="CASIO" img={Watches2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          </strong>

          </div>

          <div className="home__prd1">

          
          <Product1 id="watchem3" prdName="TIMEX" img={Watches3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="watchem4" prdName="G-SHOCK" img={Watches4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 id="watchem5"prdName="REAL ME" img={Watches5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 id="watchem6"prdName="SMARTWATCH" img={Watches6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 id="watchem7"prdName="I-BALL" img={Watches7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 id="watchem8"prdName="SEIKO" img={Watches8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}